import React from 'react';
import { connect } from 'react-redux';

import { ARIA_LIVE_REGION_ROOT } from 'constants/appConstants';

import PortalFactory from 'components/common/PortalFactory';

export const AriaLiveRoot = () => (
  <div
    id={ARIA_LIVE_REGION_ROOT}
    className="screenReadersOnly"
    role="log"
    aria-live="polite"
    aria-atomic="true"
  />
);

// This component is for reporting client side changes to the screen reader using the aria-live feature.
// You can provide anything as children to this component and it will render it to the Aria Live root
const AriaLive = PortalFactory(ARIA_LIVE_REGION_ROOT);
export default AriaLive;

export const ClientRouteOnlyAriaLive = connect(state => ({ active : state.pageView.clientRoutedUrls.length }))(AriaLive);
